<template>
  <div class="history-container">
    <div class="title">
      <em class="fa fa-history color-orange" />
      <span class="text">Historial de Comentarios</span>
    </div>
    <time-line v-if="history.length" class="mt-4 timeline_extended">
      <time-line-item
        v-for="(item, index) in history"
        :key="`comment-${index}`"
      >
        <template #date>
          <div class="date-container">
            <span class="d-block font-weight-bold">
              {{ item.date | date }}
            </span>
            <span class="hour">
              {{ item.date | hour }}
            </span>
          </div>
        </template>
        <div class="description-container">
          <span class="user">
            {{ item.userName || '-' }}
          </span>
          <p class="content">
            {{ item.comment }}
          </p>
        </div>
      </time-line-item>
    </time-line>
    <custom-result-not-found
      v-else
      text="La solicitud no cuenta con comentarios en sistema."
    />
  </div>
</template>

<script>
import CustomResultNotFound from 'custom-result-not-found';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';

export default {
  name: 'CommentsHistory',
  components: { CustomResultNotFound, TimeLine, TimeLineItem },
  props: {
    history: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.history-container {
  --dark-gray: #3f5b60;
  --gray-light: #707070;
  --gray: #727272;

  padding: 1rem;
  .title {
    margin-bottom: 0.5rem;
    .text {
      margin-left: 0.4rem;
      font-weight: bold;
      color: var(--dark-gray);
    }
  }
  .timeline_extended ::v-deep {
    .timeline__item {
      .date-container {
        text-align: right;
        font-size: 12px;
        .hour {
          color: var(--gray-light);
        }
      }
      .timeline__content {
        &--inner {
          padding: 1rem 1.5rem !important;
          .description-container {
            display: flex;
            flex-direction: column;
            font-size: 14px;
            .user {
              color: var(--dark-gray);
            }
            .content {
              color: var(--gray);
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}
</style>
